<template>
  <article :class="['container', {'promotion__main': !top}]">
    <div
      id="content"
      class="content">
      <v-runtime-template :template="promoTemplate"/>
    </div>
    <chatbot-wrapper v-if="chatbot === true"/>
    <a v-if="top === true" href="javascript:void(0)" class="btn_top" @click="scrollToTop"><span class="blind">TOP</span></a>
    <a :href="multicampusCourseLink" target="_blank" title="새창열림" class="btn_go"><span class="blind">더많은 과정 보러가기 ▶ PC버전</span></a>
  </article>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
import MmpTimer from '@/components/_common/mmp-timer/MmpTimer'
import { isEmpty } from 'lodash'
import AOS from 'aos'
import 'aos/dist/aos.css'
import ChatbotWrapper from '@/components/pages/contents/chatbot/ChatbotWrapper.vue'

export default {
  name: 'PromotionMain',
  metaInfo () {
    console.log('metaInfo chaged!!!')
    if (this.isNewDomain) {
      if (!isEmpty(this.promoInfo.evtExpl)) {
        return {
          base: { href: this.baseCheck ? ('/' + this.promoInfo.virtualPath + '/') : '/' },
          title: this.promoInfo.promoNm,
          meta: [
            { name: 'description', content: this.promoInfo.evtExpl },
            { property: 'og:title', content: this.promoInfo.promoNm },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: window.location.href },
            { property: 'og:description', content: this.promoInfo.evtExpl }
          ]
        }
      } else {
        return {
          base: { href: this.baseCheck ? ('/' + this.promoInfo.virtualPath + '/') : '/' },
          title: this.promoInfo.promoNm
        }
      }
    } else {
      if (!isEmpty(this.promoInfo.evtExpl)) {
        return {
          base: { href: '/' + this.promoInfo.contextPath + '/' },
          title: this.promoInfo.promoNm,
          meta: [
            { name: 'description', content: this.promoInfo.evtExpl },
            { property: 'og:title', content: this.promoInfo.promoNm },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: window.location.href },
            { property: 'og:description', content: this.promoInfo.evtExpl }
          ]
        }
      } else {
        return {
          base: { href: '/' + this.promoInfo.contextPath + '/' },
          title: this.promoInfo.promoNm
        }
      }
    }
  },
  components: {
    VRuntimeTemplate,
    MmpTimer,
    ChatbotWrapper
  },
  data () {
    return {
      promotionHtml: '',
      baseCheck: false,
      virtualPath: '',
      top: true, // top 노출여부 (LCPLAN-10718:외국어포탈 개편)
      chatbot: false, // 챗봇 노출여부 (LCPLAN-13041:MMP챗봇 개발)
      checkboxes: {
        hottuber01: false,
        hottuber02: false,
        hottuber03: false,
        hottuber04: false,
        hottuber05: false,
        hottuber06: false
      },
      popUp1: true,
      popUp2: true,
      popUp3: true,
      // TOTALSR-72210
      tabIndex1: 1,
      tabIndex2: 1,
      tabIndex3: 1,
      tabIndex4: 1,
      tabIndex5: 1,
      tabIndex6: 1
    }
  },
  computed: {
    promoTemplate () {
      return this.promotionHtml
    },
    promoInfo () {
      return window.vue.getStore('promoInfo').state.promoInfo
    },
    isNewDomain () {
      return isEmpty(this.promoInfo.contextPath) && !isEmpty(this.promoInfo.virtualPath)
    },
    multicampusCourseLink () {
      return 'https://www.multicampus.com/course/em/corsList/corsListCommon?p_menu=OTMjTUFJTg==&p_gubun=Qw=='
    }
  },
  beforeUpdate () {
    this.baseCheck = true
  },
  updated () {
    console.log('PromotionMain updated !!')
    this.baseCheck = false

    console.log('##this.virtualPath:#', this.virtualPath)
    if (this.virtualPath === 'outloud') {
      // var timer = setInterval(() => {
      //   this.$nextTick(function () {
      //     if (AOS) {
      //       AOS.init()
      //       this.virtualPath = ''
      //       clearInterval(timer)
      //     }
      //   })
      // }, 500)
      this.$nextTick(function () {
        AOS.init({offset: 200})
        AOS.refresh()
        this.virtualPath = ''
      })
    }

    this.$nextTick(function () {
      if (!this.top && window.location.hash === '#speak') {
        setTimeout(() => {
          this.scrollToSpeak()
        }, 1500)
      } else if (!this.top && window.location.hash === '#opic') {
        setTimeout(() => {
          this.scrollToOpic()
        }, 1500)
      }
    })
  },
  created () {
    this.getTemplate()
    var path = window.location.pathname
    var setTime = 1500

    if (path.length > 1) {
      setTime = 10
    }
    console.log('setTime' + setTime)
    setTimeout(function () {
      this.baseCheck = true
    }.bind(this), setTime)
  },
  methods: {
    uncheckCheckbox (id) {
      // 'course__hottuber' 클래스를 가진 요소들을 찾습니다.
      const courseHottuberElements = document.querySelectorAll('.course__hottuber')

      // 'course__hottuber' 클래스가 없는 경우 동작하지 않습니다.
      if (courseHottuberElements.length === 0) {
        return
      }

      // 클래스를 가진 요소들 중에서 data-close 속성 값과 일치하는 ID를 가진 체크박스를 찾아서 체크 해제합니다.
      courseHottuberElements.forEach(element => {
        const checkbox = element.querySelector(`input[id="${id}"]`)
        if (checkbox) {
          checkbox.checked = false
        }
      })
    },
    toastCopySuccess (e) {
      this.$popup.toast('복사되었습니다.')
    },
    getTemplate () {
      let resourceUrl = ''

      if (this.isNewDomain) {
        resourceUrl = this.promoInfo.virtualPath + '/index.html.org'
      } else {
        resourceUrl = this.promoInfo.contextPath + '/index.html.org'
      }

      // top 노출여부 (LCPLAN-10718 외국어포탈 개편)
      this.top = !(this.promoInfo.virtualPath.startsWith('outloud') || this.promoInfo.virtualPath.startsWith('opic') || this.promoInfo.virtualPath.startsWith('speak'))

      // 챗봇 노출여부 (LCPLAN-13041:MMP챗봇 개발)
      const chatbotShowPathList = ['multicampusmain', 'frontend', 'backend', 'hpefront', 'cloud', 'kdigital', 'kdigital3', 'kdigital4']
      if (chatbotShowPathList.indexOf(this.promoInfo.virtualPath) > -1) this.chatbot = true

      this.$http.loadRes(resourceUrl).then( (res) => {
        // window.vue.loadRes(promoStore.state.promoInfo.contextPath + '/index.org').then( (res) => {
        this.promotionHtml = res
        if (this.promoInfo.virtualPath === 'outloud') {
          this.virtualPath = 'outloud'
        }
      })
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    scrollToSpeak () {
      var location = document.querySelector('#speak')
      location.scrollIntoView()
      setTimeout(() => {
        location.scrollIntoView()
      }, 300)

      // location.scrollIntoView({behavior: 'smooth', block: 'start'})
      // var speak = document.querySelector('.main__item10').offsetTop
      // window.scrollTo({top: speak - 100})
    },
    scrollToOpic () {
      var location = document.querySelector('#opic')
      location.scrollIntoView()
      // var opic = document.querySelector('#opic').offsetTop
      // window.scrollTo({top: opic - 50})
    },
    scrollToLink () {
      var location = document.querySelector('#link')
      location.scrollIntoView()
    },
    getLink (path) {
      window.location.href = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port)) + '/outloud' + '/#' + path
    },
    courseDetail (corsCd) {
      this.$goPage({name: 'CrsDetail', query: { corsCd: corsCd }})
    },
    closePopUp1 () {
      this.popUp1 = !this.popUp1
    },
    closePopUp2 () {
      this.popUp2 = !this.popUp2
    },
    closePopUp3 () {
      this.popUp3 = !this.popUp3
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/promotion/PromotionMain.vue